import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import styles from './VpMediaViewList.module.less';
import VpMediaViewListItem from './VpMediaViewListItem';

export const VpMediaViewList = ({ mediaList = [], onClick, selectedMediaId, mediaLabels }) => {
  return (
    <Stack direction="row" spacing={'10px'} alignItems="center" className={styles.vpMediaList}>
      {mediaList?.map((media) => (
        <VpMediaViewListItem
          media={media}
          onClick={onClick}
          selectedMediaId={selectedMediaId}
          key={media?.mediaId || media?.attachmentId}
          mediaLabel={mediaLabels[media?.mediaId || media?.attachmentId]}
        />
      ))}
    </Stack>
  );
};

VpMediaViewList.propTypes = {
  mediaList: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
  selectedMediaId: PropTypes.string,
  mediaLabels: PropTypes.object
};

export default VpMediaViewList;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpMediaViewList/VpMediaViewList.jsx